export default __webpack_public_path__ + "static/selapp-joy-d562967b0cdbac9f234c46780180a272.jpg";